'use es6';

import { Record } from 'immutable';
export default Record({
  adId: null,
  adNetwork: null,
  groupId: null,
  previewBody: null,
  previewFormat: null
});